import { ResourceList, UntranslatedResourceList, ResourceNavItem, UntranslatedResourceNavItem } from '../models/Navigation'
import { LanguageString } from '../models/Language'
import { translateResourceList, translateResourceNavItem } from '../helper/navigation'
import getSubdomain from '../utils/getSubdomain'

const medicareEnv = process.env.REACT_APP_MEDICARE_ENV || ''
const mymedicareEnv = process.env.REACT_APP_MY_MEDICARE_ENV || ''
const accountMyMedicareEnv = process.env.REACT_APP_ACCOUNT_MYMEDICARE_ENV || ''

const medicareSubdomain = getSubdomain(medicareEnv)
const mymedicareSubdomain = getSubdomain(mymedicareEnv)
const accountMyMedicareSubdomain = getSubdomain(accountMyMedicareEnv)
const esMedicareSubdomain = getSubdomain(medicareEnv, 'www')

export const resourceNav: UntranslatedResourceNavItem[] = [
  {
    id: 'resource-nav-1',
    labels: {
      en: 'Basics',
      es: 'lo Esencial'
    },
    subsections: [
      {
        id: 'basics-section-1',
        labels: {
          en: 'Learn',
          es: 'Aprenda'
        },
        links: [
          {
            id: '1',
            labels: {
              en: 'Getting started with Medicare',
              es: 'Comenzando con Medicare'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/sign-up-change-plans/get-started-with-medicare`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/sign-up-change-plans/get-started-with-medicare`
            }
          },
          {
            id: '2',
            labels: {
              en: 'Medicare costs',
              es: 'Costos de Medicare'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/your-medicare-costs`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/your-medicare-costs`
            }
          },
          {
            id: '3',
            labels: {
              en: 'Your Medicare rights',
              es: 'Sus derechos en Medicare'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/claims-appeals/your-medicare-rights`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/claims-appeals/your-medicare-rights`
            }
          },
          {
            id: '4',
            labels: {
              en: 'Identity theft & fraud: protect yourself',
              es: 'Robo de identidad y fraude: protéjas'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/forms-help-resources/help-fight-medicare-fraud`, // was medicare.gov/forms-help-resources/identity-theft-protect-yourself
              es: `https://es.${esMedicareSubdomain}medicare.gov/forms-help-resources/help-fight-medicare-fraud`
            }
          }
        ]
      },
      {
        id: 'basics-section-2',
        labels: {
          en: 'Resources',
          es: 'Recursos'
        },
        links: [
          {
            id: '1',
            labels: {
              en: 'Phone numbers & websites',
              es: 'Números de teléfono y sitios web'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/Contacts/`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/Contacts/`
            }
          },
          {
            id: '2',
            labels: {
              en: 'Forms, help, & other resources',
              es: 'Formularios, ayuda y otros recursos'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/forms-help-resources`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/forms-help-resources`
            }
          },
          {
            id: '3',
            labels: {
              en: '“Medicare & You” handbook',
              es: 'Manual "Medicare y Usted"'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/medicare-and-you`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/medicare-and-you`
            }
          },
          {
            id: '4',
            labels: {
              en: 'Advance directives & long term care',
              es: 'Instrucciones anticipadas y el cuidado a largo plazo'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/manage-your-health/`, // was medicare.gov/manage-your-health/advance-directives-long-term-care
              es: `https://es.${esMedicareSubdomain}medicare.gov/manage-your-health`
            }
          }
        ]
      }
    ]
  },
  {
    id: 'resource-nav-2',
    labels: {
      en: 'Health & Drug Plans',
      es: 'Planes de Salud y Medicamentos'
    },
    subsections: [
      {
        id: 'plans-section-1',
        labels: {
          en: 'Find & Compare',
          es: 'Buscar y comparar' // google translated
        },
        links: [
          {
            id: '1',
            labels: {
              en: 'Find health & drug plans',
              es: 'Encuentre planes de salud y medicamentos'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/plan-compare/`,
              es: `https://${medicareSubdomain}medicare.gov/plan-compare/#/?lang=es`
            }
          },
          {
            id: '2',
            labels: {
              en: 'Compare coverage options',
              es: 'Compare las opciones de cobertura'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/medicarecoverageoptions/`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/medicarecoverageoptions/`
            }
          },
          {
            id: '3',
            labels: {
              en: 'Find a Medicare Supplement Insurance (Medigap) policy',
              es: 'Encuentre una póliza de Seguro Sumplementario de Medicare (Medigap)'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/medigap-supplemental-insurance-plans/`,
              es: `https://${medicareSubdomain}medicare.gov/medigap-supplemental-insurance-plans/#/m?lang=es`
            }
          }
        ]
      },
      {
        id: 'plans-section-2',
        labels: {
          en: 'Learn',
          es: 'Aprenda'
        },
        links: [
          {
            id: '1',
            labels: {
              en: 'Getting started with health & drug plans',
              es: 'Introducción a los planes de salud y medicamentos'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/sign-up-change-plans`, // was medicare.gov/sign-up-change-plans/joining-a-health-or-drug-plan
              es: `https://es.${esMedicareSubdomain}medicare.gov/sign-up-change-plans`
            }
          },
          {
            id: '2',
            labels: {
              en: 'What health plans cover',
              es: 'Que cubren los planes de salud'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/what-medicare-covers/what-medicare-health-plans-cover`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/what-medicare-covers/what-medicare-health-plans-cover`
            }
          },
          {
            id: '3',
            labels: {
              en: 'How plans work with other coverage',
              es: 'Cómo funcionan los planes con otra cobertura'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/supplements-other-insurance`, // was medicare.gov/supplements-other-insurance/how-medicare-works-with-other-insurance
              es: `https://es.${esMedicareSubdomain}medicare.gov/supplements-other-insurance`
            }
          },
          {
            id: '4',
            labels: {
              en: 'Drug coverage (Part D)',
              es: 'Cobertura de medicamentos (Parte D)'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/drug-coverage-part-d`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/drug-coverage-part-d`
            }
          }
        ]
      },
      {
        id: 'plans-section-3',
        labels: {
          en: 'My Information',
          es: 'Mi Información'
        },
        descriptions: {
          en: 'Looking for your health & drug plan information?',
          es: '¿Busca información sobre su plan de salud y medicamentos?'
        },
        unauthedOnly: true,
        links: [
          {
            id: '1',
            labels: {
              en: 'Log in/create an account',
              es: 'Iniciar sesión/crear una cuenta'
            },
            hrefs: {
              en: `https://${accountMyMedicareSubdomain}medicare.gov/account/login`,
              es: `https://${accountMyMedicareSubdomain}medicare.gov/account/login?Lang=es-mx`
            }
          }
        ]
      }
    ]
  },
  {
    id: 'resource-nav-3',
    labels: {
      en: 'Providers & Services',
      es: 'Proveedores y Servicios'
    },
    subsections: [
      {
        id: 'providers-section-1',
        labels: {
          en: 'Find & Compare',
          es: 'Buscar y comparar' // google translated
        },
        links: [
          {
            id: '1',
            labels: {
              en: 'Find care',
              es: 'Encontrar cuidado'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/care-compare/`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/care-compare/`
            }
          },
          {
            id: '2',
            labels: {
              en: 'Find medical equipment & suppliers',
              es: 'Encontrar equipos médicos y proveedores'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/supplierdirectory/search.html`, // was medicare.gov/coverage/durable-medical-equipment-dme-coverage
              es: `https://es.${esMedicareSubdomain}medicare.gov/coverage/durable-medical-equipment-dme-coverage`
            }
          },
          {
            id: '3',
            labels: {
              en: 'Compare procedure costs',
              es: 'Comparar los costos del procedimiento'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/procedure-price-lookup/`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/procedure-price-lookup/`
            }
          }
        ]
      },
      {
        id: '2',
        labels: {
          en: 'Learn',
          es: 'Aprenda'
        },
        links: [
          {
            id: '1',
            labels: {
              en: 'What Medicare covers',
              es: 'Lo que cubre Medicare'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/what-medicare-covers`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/what-medicare-covers`
            }
          },
          {
            id: '2',
            labels: {
              en: 'Claims & appeals',
              es: 'Reclamaciones y apelaciones'
            },
            hrefs: {
              en: `https://${medicareSubdomain}medicare.gov/claims-appeals`,
              es: `https://es.${esMedicareSubdomain}medicare.gov/claims-appeals`
            }
          }
        ]
      },
      {
        id: '3',
        labels: {
          en: 'My Information',
          es: 'Mi Información'
        },
        descriptions: {
          en: 'Looking for your providers & services information?',
          es: '¿Busca información sobre sus proveedores y servicios?'
        },
        unauthedOnly: true,
        links: [
          {
            id: '1',
            labels: {
              en: 'Log in/create an account',
              es: 'Iniciar sesión/crear una cuenta'
            },
            hrefs: {
              en: `https://${accountMyMedicareSubdomain}medicare.gov/account/login`,
              es: `https://${accountMyMedicareSubdomain}medicare.gov/account/login?Lang=es-mx`
            }
          }
        ]
      }
    ]
  }
]

export const accountNav: UntranslatedResourceList[] = [
  {
    id: 'account-nav-1',
    labels: {
      en: 'My Account',
      es: 'Mi Cuenta'
    },
    links: [
      {
        id: '1',
        labels: {
          en: 'My account home',
          es: 'Iniciar mi cuenta'
        },
        hrefs: {
          en: `https://${mymedicareSubdomain}mymedicare.gov/dashboard.aspx`,
          es: `https://${mymedicareSubdomain}mymedicare.gov/dashboard.aspx?Lang=es-mx`
        }
      },
      {
        id: '2',
        labels: {
          en: 'My account settings',
          es: 'Configuración de mi cuenta'
        },
        hrefs: {
          en: `https://${mymedicareSubdomain}mymedicare.gov/myaccount.aspx`,
          es: `https://${mymedicareSubdomain}mymedicare.gov/myaccount.aspx?Lang=es-mx`
        }
      },
      {
        id: '3',
        labels: {
          en: 'Download my claims & personal data',
          es: 'Descargar mis reclamaciones y datos personales'
        },
        hrefs: {
          en: `https://${mymedicareSubdomain}mymedicare.gov/DownloadMyData.aspx`,
          es: `https://${mymedicareSubdomain}mymedicare.gov/DownloadMyData.aspx?Lang=es-mx`
        }
      }
    ]
  },
  {
    id: 'account-nav-2',
    labels: {
      en: 'My Information',
      es: 'Mi Información'
    },
    links: [
      {
        id: '1',
        labels: {
          en: 'My claims',
          es: 'Mis reclamaciones'
        },
        hrefs: {
          en: `https://${mymedicareSubdomain}mymedicare.gov/claimsearchresult.aspx`,
          es: `https://${mymedicareSubdomain}mymedicare.gov/claimsearchresult.aspx?Lang=es-mx`
        }
      },
      {
        id: '2',
        labels: {
          en: 'My premiums',
          es: 'Mis primas'
        },
        hrefs: {
          en: `https://${mymedicareSubdomain}mymedicare.gov/PremiumInformation.aspx`,
          es: `https://${mymedicareSubdomain}mymedicare.gov/PremiumInformation.aspx?Lang=es-mx`
        }
      },
      {
        id: '3',
        labels: {
          en: 'My plans',
          es: 'Mis planes'
        },
        hrefs: {
          en: `https://${mymedicareSubdomain}mymedicare.gov/plansandcoverage.aspx`,
          es: `https://${mymedicareSubdomain}mymedicare.gov/plansandcoverage.aspx?Lang=es-mx`
        }
      },
      {
        id: '4',
        labels: {
          en: 'My preventive services',
          es: 'Mis servicios preventivos'
        },
        hrefs: {
          en: `https://${mymedicareSubdomain}mymedicare.gov/mypreventiveservices.aspx`,
          es: `https://${mymedicareSubdomain}mymedicare.gov/mypreventiveservices.aspx?Lang=es-mx`
        }
      },
      {
        id: '5',
        labels: {
          en: 'My providers',
          es: 'Mis proveedores'
        },
        hrefs: {
          en: `https://${mymedicareSubdomain}mymedicare.gov/myproviders.aspx`,
          es: `https://${mymedicareSubdomain}mymedicare.gov/myproviders.aspx?Lang=es-mx`
        }
      },
      {
        id: '6',
        labels: {
          en: 'My saved drugs & pharmacies',
          es: 'Mis farmacias y medicamentos guardados'
        },
        hrefs: {
          en: `https://${mymedicareSubdomain}mymedicare.gov/drugsandpharmacies.aspx`,
          es: `https://${mymedicareSubdomain}mymedicare.gov/drugsandpharmacies.aspx?Lang=es-mx`
        }
      }
    ]
  }
]

export const getAccountNav = (lang: LanguageString = 'en'): ResourceList[] => {
  return accountNav.map(list => translateResourceList(list, lang))
}

export const getResourceNavItems = (lang: LanguageString = 'en'): ResourceNavItem[] => {
  return resourceNav.map(resourceNavItem => translateResourceNavItem(resourceNavItem, lang))
}
